import React, { useMemo } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import MapView from "../../components/MapView/MapView";
import OnboardingTutorial from "../../components/OnboardingTutorial/OnboardingTutorial";
import PageLayout from "../../components/PageLayout/PageLayout";
import { auth } from "../../firebase";
import useOnboardingStatus from "../../hooks/useOnboardingStatus";
import { SitePage } from "../../types/SitePage";
import "./MapPage.scss";

const MapPage: React.FC = () => {
  const [user, loadingAuth] = useAuthState(auth);

  const {
    onboardingCompleted,
    loadingOnboardingStatus,
    handleFinishOnboarding,
    handleSkipOnboarding,
  } = useOnboardingStatus(user ?? null);

  const showOnboarding = useMemo(() => {
    return (
      onboardingCompleted === false && !loadingOnboardingStatus && !loadingAuth
    );
  }, [onboardingCompleted, loadingOnboardingStatus, loadingAuth]);

  return (
    <PageLayout page={SitePage.Map} title="Map">
      <div className="map-page-container">
        {showOnboarding && (
          <OnboardingTutorial
            onFinish={handleFinishOnboarding}
            onSkip={handleSkipOnboarding}
          />
        )}
        <MapView />
      </div>
    </PageLayout>
  );
};

export default MapPage;
